import jwtDecodeImpl from 'jwt-decode';

export function jwtDecode(token: string) {
  try {
    return jwtDecodeImpl<{ auth_time: number; iat: number; exp: number }>(
      token,
    );
  } catch (e) {
    console.error('error decoding user auth token: ', e);
  }
  return undefined;
}

export function isTokenExpired(token: string, threshold = 0) {
  const tokenInfo = jwtDecode(token);
  return tokenInfo != null && tokenInfo.exp * 1000 - threshold <= Date.now();
}
